<template>
  <div class="products">
    <div style="width: 100%" v-if="subCategories && subCategories.length > 0">
      <div
        style="border-radius: 10px"
        class="bg-white shadow flex flex-col px-4 py-6 mb-6 subcategories"
        v-for="(subCategory, index) in subCategories"
        :key="index"
      >
        <h4 class="subcategory">{{ subCategory.title }}</h4>
        <div class="product-cont">
          <product
            v-for="(product, index) in subCategory.items"
            :key="index"
            :product="product"
            :shoppingCard="shoppingCard"
            @select="$emit('select', product)"
            @remove="$emit('remove', product)"
          ></product>
        </div>
      </div>
    </div>
    <div
      style="border-radius: 10px"
      class="bg-white shadow flex flex-col px-4 py-6 mb-6 subcategories"
      v-else-if="products && products.length > 0"
    >
      <div class="product-cont">
        <product
          v-for="(product, index) in products"
          :key="index"
          :product="product"
          :shoppingCard="shoppingCard"
          @select="$emit('select', product)"
          @remove="$emit('remove', product)"
        ></product>
      </div>
    </div>
    <vs-alert v-else color="warning" icon-pack="feather" icon="icon-info">
      محصولی جهت نمایش موجود نیست
    </vs-alert>
  </div>
</template>

<script>
  import Product from "./Product.vue";

  export default {
    name: "Products",
    components: { Product },
    data() {
      return {
        activeSubCategory: null,
        products: this.activeCategory ? this.activeCategory.items : null,
        subCategories: this.activeCategory
          ? this.activeCategory.subCategories
          : null,
        title: this.activeCategory ? this.activeCategory.title : null,
      };
    },
    watch: {
      activeCategory(category) {
        this.products = category ? category.items : null;
        this.subCategories = category ? category.subCategories : null;
      },
    },
    props: {
      shoppingCard: {
        type: Array,
        required: true,
      },
      activeCategory: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  .products {
    display: flex;
    flex-direction: column;
    min-height: 600px;

    @media (max-width: 700px) {
      margin-left: 0;
    }

    .subcategories {
      margin-bottom: 32px;

      @media (max-width: 700px) {
        margin-bottom: 24px;
      }
    }
  }

  .product-cont {
    display: grid;
    grid-template-columns: repeat(auto-fill, var(--card-width));
    justify-content: start;
    gap: 16px;

    @media (max-width: 375px) {
      --card-width: 145px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 376px) and (max-width: 400px) {
      --card-width: 155px;
      justify-content: space-between;
      gap: 8px;
    }
    @media (min-width: 401px) and (max-width: 420px) {
      --card-width: 155px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 421px) and (max-width: 765px) {
      --card-width: 160px;
      justify-content: space-between;
      gap: 8px;
    }

    @media (min-width: 766px) {
      --card-width: 170px;
    }
  }

  .subcategory {
    font-size: 14px;
    margin-bottom: 16px;

    @media (max-width: 430px) {
      margin-bottom: 24px;
    }
  }
</style>
